import styled from 'styled-components';

const H1 = styled.h1`
  font-size: 52px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin: 0;
  ${({ theme }) => theme.media.md.min`
  font-size: 86px;
   `}
  ${({ theme }) => theme.media.lg.min`
  font-size: 86px;
   `}
`;

export default H1;
